
import {AddQualificationRecordBase} from "./AddQualificationRecordBase";
import Component from "vue-class-component";
import {
  EducationalInstitution,
  EducationalQualificationOptions,
  EducationalQualificationRecordModel,
  factory, QualificationRecordsClient, QualificationsClient, ResultError,
  AvailableActions
} from "@/api-client";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import FileUploader from "@/components/FileUploader.vue";
import Files from '@/components/Files.vue';
import LabelOptional from "@/features/shared/components/LabelOptional.vue";
import toasts from "@/components/Toasts";
import Loader from "@/features/shared/components/Loader";
import moment from "moment";
import {Prop} from "vue-property-decorator";
import {NavigationGuardNext} from "vue-router/types/router";

interface Props {
  qualificationPreloadedActions: AvailableActions;
}

@Component({
  components: {
    Files,
    FileUploader,
    HeadingWave,
    LabelOptional,
    SectionPageHeading,
  },
  async beforeRouteEnter(to, from, next : NavigationGuardNext<AddEducationalQualificationRecord>) {
      const props = to.meta!.props as Props;
      Promise.all([
          new QualificationRecordsClient().availableActions(),
      ]).then(values => {
          props.qualificationPreloadedActions = values[0];
          next();
      }).catch(e => next(e))
  }
})
export default class AddEducationalQualificationRecord extends AddQualificationRecordBase {
  @Prop({ required: true })
  qualificationPreloadedActions!: AvailableActions;

  record: EducationalQualificationRecordModel = factory.create(EducationalQualificationRecordModel);
  options: EducationalQualificationOptions = factory.create(EducationalQualificationOptions);
  errors: ResultError = factory.create(ResultError);
  isCreated = false;
  isSubmitted = false;
  submitLoader = new Loader();
  duplicateWarning?:null|boolean = false;

  async created() {
    this.options = await new QualificationsClient().educationalOptions();
    this.selectedInstitution = null;
    const id = this.$route.params.id;
    if (id) {
      this.record = await new QualificationRecordsClient().getEducationalRecord(id);
      this.isSubmitted = !!this.record.submittedOn;
      this.options.educationalInstitutions = this.options.educationalInstitutions.filter(i => i.active || i.id == this.record.educationalInstitutionId);
      this.selectedInstitution = this.options.educationalInstitutions.filter(i => i.id == this.record.educationalInstitutionId)[0];
      this.record.comment = null;
      this.duplicateWarning = this.record.duplicateWarning;
      console.log(this.record, this.duplicateWarning);
    }
    else{
      this.options.educationalInstitutions = this.options.educationalInstitutions.filter(i => i.active);
    }
    this.isCreated = true;

    this.$watch(() => this.record, () => {
          if(this.record.issuedOn && moment().startOf("day").diff(this.record.issuedOn) < 0){
              this.errors.clearKey("issuedOn");
              this.errors.appendMessage(this.$ls.Global_IssuedOn_In_The_Future,"issuedOn");
          }
          else{
              this.errors.clearKey("issuedOn");
          }
          if(this.record.issuedOn && this.record.validUntil){
              if(moment(this.record.validUntil).diff(this.record.issuedOn) <= 0){
                  this.errors.clearKey("validUntil");
                  this.errors.appendMessage(this.$ls.Global_ValidUntil_Before_IssuedOn,"validUntil");
              }
              else{
                  this.errors.clearKey("validUntil");
              }
          }
      },{ deep: true });
  }

  async save() {
    this.submitLoader.startLoading();
      this.errors = factory.create(ResultError);
    await new QualificationRecordsClient().addRecord(this.record).then(
        result => {
          toasts.success(this.$ls.Global_Toast_SaveSuccess)
          this.navigateToDetails(result.id ?? "");
        },
        error => this.setValidationErrors(error, this.$ls.Global_Toast_FormSaveFailure, "errors"));
    this.submitLoader.endLoading();
  }

  async navigateToDetails(id: string) {
    await this.$router.replace({name: "educationalRecordDetails", params: {id: id}});
  }

  async getDownloadUrl(fileId: string): Promise<string> {
    return (await new QualificationRecordsClient().downloadEducationalRecordFile(this.$route.params.id, fileId)).url;
  }

  get selectedSpecialityEducation() {
    const speciality = this.options.specialities.filter(t => t.id === this.record.speciality)[0];
    return speciality?.education ?? "";
  }
  getDescription(educationalInstitution: EducationalInstitution) {
      return `${educationalInstitution.name}`;
  }
  get noResultText() {
      return this.$ls.Global_Placeholder_Searching
  }

  get specialities(){
    if(this.selectedInstitution && this.selectedInstitution.specialities && this.selectedInstitution.specialities.length>0){
      const specialitiesFlat = this.selectedInstitution.specialities.map(m => m.value);
      return this.options.specialities.filter(f => specialitiesFlat.includes(f.id))
    }
    return this.options.specialities;
  }
}
